import {configureStore,combineReducers} from "@reduxjs/toolkit";
import assessmentReducer from "./assessmentSlide"
import authReducer from "./authSlide"
import programReducer from "./programSlide"
import storage from 'redux-persist/lib/storage';
import thunk from 'redux-thunk';
import { persistReducer, persistStore, createTransform } from 'redux-persist';

// Área privada del psicólogo: los mensajes del chat (datos clínicos, con avatares en base64) no se
// guardan en localStorage. Antes se escribía el historial completo de cada chat en cada mensaje:
// quedaba información clínica en el navegador y se podía agotar la cuota. Los mensajes llegan de
// RTDB al abrir el chat; los contadores de no leídos sí se conservan. La web del paciente no cambia.
const PRACTITIONER_ROLES = ['SPECIALIST', 'SUPERVISOR', 'ADMIN'];
const isPractitioner = (fullState) => {
    const role = String(fullState?.auth?.userDetails?.role || '').toUpperCase();
    return PRACTITIONER_ROLES.some((r) => role.includes(r));
};
const dropPractitionerChatMessages = createTransform(
    (programsState, key, fullState) => {
        if (!isPractitioner(fullState) || !programsState?.communications) return programsState;
        return {
            ...programsState,
            communications: { ...programsState.communications, chatMessages: [], communityMessages: [] },
        };
    },
    (programsState) => programsState,
    { whitelist: ['programs'] }
);

const persistConfig = {
    key: 'root',
    storage,
    transforms: [dropPractitionerChatMessages],
}

const rootReducer = {
    assessment: assessmentReducer,
    auth: authReducer,
    programs: programReducer
};
const persistedReducer = persistReducer(persistConfig, combineReducers(rootReducer))

export const store =  configureStore({
    reducer: persistedReducer,
    middleware: [thunk]
})

export const persistor = persistStore(store)
